import words from 'lodash/words'
import isNil from 'lodash/isNil'
import take from 'lodash/take'
import * as React from 'react'
import AvatarCore from 'react-avatar'

export type AvatarProps = {
  name?: string
  src?: string | null | undefined
  skipImageName?: string | null
  tooltip?: string
  size?: number
  textSizeRatio?: number
  value?: any
  color?: string
}
/**
 *  The common avatar
 */

export const Avatar = ({
  name,
  skipImageName = null,
  src,
  tooltip,
  size = 32,
  textSizeRatio = 1.75,
  value,
  ...rest
}: AvatarProps) => {
  if (src && skipImageName && src.includes(skipImageName)) src = null

  //src will be null if it is the default image
  if (src) {
    const hasDefaultImage = src?.endsWith('dft-customer.jpg')
    if (hasDefaultImage) {
      src = null
    }
  }
  //remove the numbers and show only the names
  //102.32 Jenny Rose will be Jenny Rose only
  //if there is a value ignore the name
  if (!isNil(value)) {
    name = name?.replace(/[^\sa-zA-Z_]/g, '').trim()
    name = name || 'N / A'
  }

  tooltip = tooltip || name || value

  const defaultProps = {
    round: true,
    size: size.toString(),
    textSizeRatio,
    src,
    name: take(words(name), 3).join(' '), //we take only the first 3 words
    title: tooltip,
    ...rest,
  }

  return <AvatarCore {...defaultProps} />
}
